import React from 'react'
import RecoverPassword from '../../../components/form/forgotPassword'



/*const initialValues = { email: '', password: '' }
const validations = yup.object().shape({
  email: yup
    .string()
    .email('Email no válido')
    .required('Campo requerido'),
  password: yup.string().required('Campo requerido')
})


FormLogin.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleSeePaswordChange: PropTypes.func.isRequired
}
  */

function ForgotPassword() {
  return (
    <RecoverPassword/>
  )
}

export default ForgotPassword;